/*
* Initial solution to collect localized entries.
 */

import {
  BadRequestErrorCode,
  ForbiddenErrorCode,
  InternalServerErrorCode,
  NotFoundErrorCode,
  ServiceUnavailableErrorCode,
  UnauthorizedErrorCode,
  UnknownNetworkErrorCode
} from "../api/ApiUtil";
import {ProductType} from '../enum/productType'

export enum Language {
  FI = 'FI',
  EN = 'EN'
}

/**
 * Get localized error by error key.
 * TODO: take 'react-i18next' into use and move these there.
 * @param errorKey error key returned by backend.
 * @param lang language to localize the value.
 */
function getLocalizedErrorMessage(errorKey: string, lang: Language): string | undefined {
  if (lang === Language.FI) {
    switch (errorKey) {
      case 'api.admin.users.create.userExists':
        return 'Käyttäjä on jo olemassa'
      case 'api.admin.users.update.emailConflict':
        return 'Sähköpostiosoite ei vastaa järjestelmän tuntemaa osoitetta'
      case 'api.admin.users.update.notFound':
        return 'Päivitettävää käyttäjää ei löydy'
    }
  }

  return undefined
}

/**
 * Convert HTTP error status code into localized error.
 * TODO: take 'react-i18next' into use and move these there.
 * @param statusCode HTTP (error) status code (returned by the API object(s).
 * @param lang language to localize the value.
 */
function getLocalizedHttpError(statusCode: number, lang: Language): string {
  if (lang === Language.FI) {
    switch (statusCode) {
      // note: in the cloud environment when backend is unavailable, 'service unavailable' is returned.
      // When user has no network connection (or backend is down on local development env, unknown error code is used)
      case ServiceUnavailableErrorCode:
      case UnknownNetworkErrorCode:
        return 'Yhteysvirhe. Yritä myöhemmin uudelleen.'
      case BadRequestErrorCode:
        return 'Virheellinen pyyntö.'
      case UnauthorizedErrorCode:
        return 'Sessio vanhentunut. Uudelleenkirjautuminen vaadittu.'
      case ForbiddenErrorCode:
        return 'Käyttö estetty!'
      case InternalServerErrorCode:
        return 'Tuntematon virhe. Yritä myöhemmin uudelleen.'
      case NotFoundErrorCode:
        return 'Resurssia ei löydy.'
      default:
        return 'Virhe!'
    }
  }

  return 'Unknown error'
}

/**
 * Convert product type into localized value.
 * @param productType
 * @param lang
 */
function getLocalizedProductType(productType: ProductType, lang: Language): string {
  if (lang === Language.FI) {
    switch (productType) {
      case ProductType.AmbientSensor:
        return 'Lämpötila/kosteusanturi'
      case ProductType.ApartmentScreen:
        return 'Huoneistonäyttö'
      case ProductType.CenterUnit:
        return 'Keskus-moduuli'
      case ProductType.SmokeDetector:
        return 'Palovaroitin'
      case ProductType.WaterMeter:
        return 'Vesimittari'
      case ProductType.Unknown:
        return 'Tuntematon'
    }
  }

  return 'Unknown'
}

type NotificationType = "success" | "error" | "warn" | "info"

function getLocalizedNotificationTitle(type: NotificationType, lang: Language = Language.FI): string {
  if (lang === Language.FI) {
    switch (type) {
      case "success":
        return ''
      case "info":
        return ''
      case "error":
        return 'Virhe: '
      case "warn":
        return 'Huomio: '
    }
  }

  return ''
}

export const Localization = {
  getLocalizedHttpError,
  getLocalizedProductType,
  getLocalizedErrorMessage,
  getLocalizedNotificationTitle
}
